import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, Checkbox, FormControlLabel, Button , Radio, RadioGroup } from "@mui/material";
import './style.css'
import "../style.css"
import anmolLogo from "../../assets/images/anmol_logo_transparent.png"
import { ToastContainer, toast } from "react-toastify";
import { fetchAllCustomer } from "assets/globalAPI/apiGlobal";

export default function CustomerType() {
  const toastId= React.useRef(null)
   const [selectedOption, setSelectedOption] = useState("");
   const [selectedCard, setSelectedCard] = useState(""); 
  const [msme, setMsme] = useState(false);
  const [fssi, setFssi] = useState(false);
  const [others, setOthers] = useState(false);
  const [noSelected, setNoSelected]= useState("");
  const [customerArr,setCustomerArr]= useState([]);
  const navigate = useNavigate();

  // Load values from localStorage when the component mounts
 

  // Update localStorage when state changes

  useEffect(() => {
    let myType= localStorage.getItem("customer_type");
    console.log("here is my type>> ", myType);
    setSelectedCard(myType);
  },[])

  const handleMsmeChange=(e)=>{
    setMsme(e.target.checked);
  }
  const handleFssiChange=(e)=>{
    setFssi(e.target.checked)
  }

  const handleCardSelection = (card) => {
    setSelectedCard(card);
  };

  const fetchCustomers=async(status)=>{
          let body;
  
            body={
             page: 1,
             reference_id: localStorage.getItem("refId"),
           }
      
          try{
            const response= await fetchAllCustomer(body);
            const res= response.data;
            console.log("printing res>>> ", res);
            if(res.status){
              console.log("fetched custs>> ", res.data);
            
              setCustomerArr(res.data);
              if(res.data.length>0 || res.data.length!==undefined || res.data!==null){
                navigate("/customer/registration-form")
 
               }
            }else{
              console.log("not fetched custs>> ", res);
              setCustomerArr([]);
              
            }
          }catch(error){
            console.log("err in cust fetch>> ", error);
            
             if(error.response?.status==403){
                        if(!toast.isActive(toastId.current)){
                          toastId.current= toast.error("Your Session has expired",{
                            className:"small-toast"
                          })
                        }
                        setTimeout(()=>{
                          navigate("/")
                          localStorage.clear();
                        },2000)
                        return;
                      }
          }
        }

        useEffect(()=>{
          fetchCustomers()
        },[])
 

  const handleProceed = () => {
      if(selectedCard===""){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.warning("Please select a customer type",{
                    className: "small-toast"
                  })
        }
        return;
      }else{
        // localStorage.setItem("customer_type",selectedCard);
        navigate("/customer/registration-form")
        return;
      }
  };

  return (
    <>
    <ToastContainer/>
    <div className="container">
    <div className="image-container">
      <img src={anmolLogo} alt="Business Image" className="business-image" />
    </div>

    <h2 className="title">Select Your Type:</h2>

    <div className="checkbox-cards-container">
      {/* First Card: Business Registrations */}
      <div className={`checkbox-card `}>
        <FormControlLabel
          control={
            <Radio
              sx={{ color: "#01040a" }}
              disabled
              checked={selectedCard==="Distributor"}
              onChange={() => handleCardSelection("Distributor")}
            />
        }
        label={<span className="checkbox-label">Distributor</span>}
        />
       
      </div>
      <div className={`checkbox-card`}>
        <FormControlLabel
          control={
            <Radio
            // disabled={selectedCard==="business"}
              sx={{ color: "#01040a" }}
              disabled
              checked={selectedCard === "Railway Distributor"}
              onChange={() => handleCardSelection("Railway Distributor")}
            />
          }
          label={<span className="checkbox-label">Railway Distributor</span>}
        />
      </div>

      <div className={`checkbox-card`}>
        <FormControlLabel
          control={
            <Radio
            // disabled={selectedCard==="business"}
              sx={{ color: "#01040a" }}
              disabled
              checked={selectedCard === "Super Stockist"}
              onChange={() => handleCardSelection("Super Stockist")}
            />
          }
          label={<span className="checkbox-label">Super Stockist</span>}
        />
      </div>
      <div className={`checkbox-card`}>
        <FormControlLabel
          control={
            <Radio
            // disabled={selectedCard==="business"}
              sx={{ color: "#01040a" }}
              disabled
              checked={selectedCard === "Sub Distributor"}
              onChange={() => handleCardSelection("Sub Distributor")}
            />
          }
          label={<span className="checkbox-label">Sub Distributor</span>}
        />
      </div>

      <div className={`checkbox-card `}>
        <FormControlLabel
          control={
            <Radio
            // disabled={selectedCard==="business"}
              sx={{ color: "#01040a" }}
              disabled
              checked={selectedCard === "Sitting Sub Distributor"}
              onChange={() => handleCardSelection("Sitting Sub Distributor")}
            />
          }
          label={<span className="checkbox-label">Sitting Sub Distributor</span>}
        />
      </div>
      <div className={`checkbox-card`}>
        <FormControlLabel
          control={
            <Radio
            // disabled={selectedCard==="business"}
              sx={{ color: "#01040a" }}
              disabled
              checked={selectedCard === "SMT Distributor"}
              onChange={() => handleCardSelection("SMT Distributor")}
            />
          }
          label={<span className="checkbox-label">SMT Distributor</span>}
        />
      </div>
      <div className={`checkbox-card`}>
        <FormControlLabel
          control={
            <Radio
            // disabled={selectedCard==="business"}
              sx={{ color: "#01040a" }}
              disabled
              checked={selectedCard === "Modern Trade/CPC/Ecommerce"}
              onChange={() => handleCardSelection("Modern Trade/CPC/Ecommerce")}
            />
          }
          label={<span className="checkbox-label">Modern Trade/ CPC/ Ecommerce</span>}
        />
      </div>



      {/* Second Card: Others */}
      {/* <div className={`checkbox-card ${selectedCard === "others" ? "active" : ""}`}>
        <FormControlLabel
          control={
            <Radio
            // disabled={selectedCard==="business"}
              sx={{ color: "#01040a" }}
              checked={selectedCard === "others"}
              onChange={() => handleCardSelection("others")}
            />
          }
          label={<span className="checkbox-label">Others</span>}
        />
      </div> */}
    </div>

    <Button variant="contained" sx={{ color: "ivory", marginTop: "30px" }} onClick={handleProceed} color="primary" className="proceed-button">
      Proceed
    </Button>
  </div>
    </>
  
  );
}


// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FormControlLabel, Checkbox, Button } from "@mui/material";
// import "./style.css";
// import "../style.css";
// import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
// import { ToastContainer, toast } from "react-toastify";

// export default function CustomerType() {
//   const toastId = React.useRef(null);
//   const [selectedOptions, setSelectedOptions] = useState([]);
//   const navigate = useNavigate();

//   const handleCheckboxChange = (option) => {
//     setSelectedOptions((prev) =>
//       prev.includes(option)
//         ? prev.filter((item) => item !== option)
//         : [...prev, option]
//     );
//   };

//   const handleProceed = () => {
//     if (selectedOptions.length === 0) {
//       if (!toast.isActive(toastId.current)) {
//         toastId.current = toast.warning("Please select at least one customer type", {
//           className: "small-toast",
//         });
//       }
//       return;
//     }
//     localStorage.setItem("customer_type", JSON.stringify(selectedOptions));
//     navigate("/customer/registration-form");
//   };

//   return (
//     <>
//       <ToastContainer />
//       <div className="container">
//         <div className="image-container">
//           <img src={anmolLogo} alt="Business" className="business-image" />
//         </div>

//         <h2 className="title">Select Your Type:</h2>

//         <div className="checkbox-cards-container">
//           {["distributor", "railway_distributor", "super_stockist", "sub_distributor", "sitting_sub_distributor", "smt_distributor", "modern_trade_cpc"].map((option) => (
//             <div key={option} className="checkbox-card">
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     sx={{ color: "#01040a" }}
//                     checked={selectedOptions.includes(option)}
//                     onChange={() => handleCheckboxChange(option)}
//                   />
//                 }
//                 label={<span className="checkbox-label">{option.replace(/_/g, " ")}</span>}
//               />
//             </div>
//           ))}
//         </div>

//         <Button
//           variant="contained"
//           sx={{ color: "ivory", marginTop: "30px" }}
//           onClick={handleProceed}
//           color="primary"
//           className="proceed-button"
//         >
//           Proceed
//         </Button>
//       </div>
//     </>
//   );
// }

